import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import ConfirmSignUpForm from './ConfirmSignUpForm';
import './AuthPage.css';

type AuthMode = 'login' | 'signup' | 'confirm';

const AuthPage: React.FC = () => {
  const [mode, setMode] = useState<AuthMode>('login');
  const [signUpUsername, setSignUpUsername] = useState('');

  const handleSwitchToSignUp = () => setMode('signup');
  const handleSwitchToLogin = () => setMode('login');
  
  const handleSignUpSuccess = (username: string) => {
    setSignUpUsername(username);
    setMode('confirm');
  };

  const handleConfirmSuccess = () => {
    setMode('login');
  };

  const handleBackToSignUp = () => {
    setMode('signup');
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Photo Gallery</h1>
          <p>Please sign in to access your photos</p>
        </div>
        
        {mode === 'login' && (
          <LoginForm onSwitchToSignUp={handleSwitchToSignUp} />
        )}
        
        {mode === 'signup' && (
          <SignUpForm 
            onSwitchToLogin={handleSwitchToLogin}
            onSignUpSuccess={handleSignUpSuccess}
          />
        )}
        
        {mode === 'confirm' && (
          <ConfirmSignUpForm
            username={signUpUsername}
            onConfirmSuccess={handleConfirmSuccess}
            onBackToSignUp={handleBackToSignUp}
          />
        )}
      </div>
    </div>
  );
};

export default AuthPage;